<div class="sam-margin">
   <div class="title sam-float-left">
      {{ displayedText }}
   </div>
   <div class="sam-full-width">
      <button kendoButton (click)="onCancel()" class="sam-float-right">{{ 'common.no' | translate }}</button>
      <button kendoButton [primary]="true" (click)="onConfirm()" class="sam-margin-right sam-float-right">
         {{ 'common.yes' | translate }}
      </button>
   </div>
</div>
